import React from 'react'
import { storiesOf } from '@storybook/react'

// Digital-Commons Theming
import { ThemeProvider } from 'styled-components'
import { getBaseTheme } from '../..'

// Subcomponents
import GridComponent from './grid/Grid.component'
import StatusComponent from './status/Status.component'
import { HeaderComponent } from './header/Header.component'
import ScrollerComponent from './scroller/Scroller.component'
import { ErrorsComponent } from './errors/Errors.component'
import FilterDrawerComponent from './filters/FilterDrawer.component'

// props
import { propsGrid } from './subcomponents-props/grid'
import { propsStatus } from './subcomponents-props/status'
import { propsHeader } from './subcomponents-props/header'
import { propsScroller } from './subcomponents-props/scroller'
import { propsFilters } from './subcomponents-props/filters'
import apiDataset from './subcomponents-props/api-dataset'

// common props
import i18n from './demos/i18n'
import Environment from './utils/environment'
import API from './api/API'

// Story
const stories = storiesOf('Digital-Commons/Datatable/SubComponents', module)

// Theming
const mode = 'refinitiv'
const baseTheme = getBaseTheme({ mode })
const builtTheme = {
  mode,
  ...baseTheme
}

// Props used by all components
const env = new Environment('TR_pageFunctions')
const api = new API(env)

api.setDataSet(apiDataset)

const propsCommon = { i18n: i18n.content, api, env }


// Stories
stories
  .add('Errors', () => (
    <ThemeProvider theme={builtTheme}>
      <ErrorsComponent error="Bonjour, an error occurred." />
    </ThemeProvider>
  ))
  .add('Filters', () => (
    <ThemeProvider theme={builtTheme}>
      <FilterDrawerComponent {...propsFilters} {...propsCommon} />
    </ThemeProvider>
  ))
  .add('Grid', () => (
    <ThemeProvider theme={builtTheme}>
      <GridComponent {...propsGrid} {...propsCommon} />
    </ThemeProvider>
  ))
  .add('Header', () => (
    <ThemeProvider theme={builtTheme}>
      <HeaderComponent {...propsHeader} {...propsCommon} />
    </ThemeProvider>
  ))
  .add('Scroller', () => (
    <ThemeProvider theme={builtTheme}>
      <ScrollerComponent {...propsScroller} />
    </ThemeProvider>
  ))
  .add('Status', () => (
    <ThemeProvider theme={builtTheme}>
      <StatusComponent {...propsStatus} {...propsCommon} />
    </ThemeProvider>
  ))

  